import { useEffect, useState } from 'react'
import { getPortalFilterOptions } from '@services/portalService'

export default function PortalRegionFilters({ estado, comarca, onChange, refreshVersion = 0 }) {
  const [options, setOptions] = useState({ estados: [], comarcas: [] })
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [retryVersion, setRetryVersion] = useState(0)

  useEffect(() => {
    let active = true
    setLoading(true)
    setError('')
    getPortalFilterOptions(estado).then((result) => {
      if (!active) return
      if (result.success) setOptions({ estados: result.data?.estados || [], comarcas: result.data?.comarcas || [] })
      else setError(result.error || 'Não foi possível carregar os estados e as comarcas da sua carteira.')
      setLoading(false)
    })
    return () => { active = false }
  }, [estado, refreshVersion, retryVersion])

  return (
    <>
      <label className="portal-field"><span>Estado</span><select value={estado} onChange={(event) => onChange('estado', event.target.value)} disabled={loading || !!error}>
        <option value="">{loading ? 'Carregando estados...' : 'Todos os estados'}</option>
        {estado && !options.estados.includes(estado) ? <option value={estado}>{estado}</option> : null}
        {options.estados.map((value) => <option key={value} value={value}>{value}</option>)}
      </select></label>
      <label className="portal-field"><span>Comarca</span><select value={comarca} onChange={(event) => onChange('comarca', event.target.value)} disabled={loading || !!error}>
        <option value="">{loading ? 'Carregando comarcas...' : 'Todas as comarcas'}</option>
        {comarca && !options.comarcas.includes(comarca) ? <option value={comarca}>{comarca}</option> : null}
        {options.comarcas.map((value) => <option key={value} value={value}>{value}</option>)}
      </select></label>
      {error ? <div className="portal-region-error portal-form-error portal-retry-error" role="alert"><span>{error}</span><button type="button" className="portal-secondary-button" onClick={() => setRetryVersion((value) => value + 1)}>Recarregar regiões</button></div> : null}
    </>
  )
}
